import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import msgHelper from "../../../helpers/msg-helper";
import memoizeOne from "memoize-one";
import _ from "lodash";
import log from "../../../util/log";

class ValidationErrors extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      parsedErrors : []
    }
  }

  componentDidMount() {
    this.updateParsedErrors(this.props.errors || []);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.errors !== this.props.errors){
      this.updateParsedErrors(this.props.errors);
    }
  }

  updateParsedErrors(errors){
    let parsedErrors = [];
    _.each(errors, (errString) => {
      let tokenized = msgHelper.parseAndTokenizeString(errString);
      if(tokenized.length > 0){
        parsedErrors.push(tokenized);
      }
      else{
        parsedErrors.push([{
          text : errString,
          id : _.uniqueId("validation_error_")
        }]);
      }
    })
    this.setState({parsedErrors});
  }

  render() {
    let { parsedErrors } = this.state;

    if(!parsedErrors || parsedErrors.length === 0) {
      return null;
    }

    return (
      <div className="alert alert-danger" role="alert">
        {parsedErrors.map((errTokens, i) => {
          return (
            <div key={i} className="text-start">
              {errTokens.map((token) => {
                if(token.useHtml){
                  return msgHelper.getLinkForToken(token);
                }
                else{
                  return (
                    <span key={token.id}>
                      {token.text}
                    </span>
                  )
                }
              })}
            </div>
          )
        })}
      </div>
    )
  }
}

ValidationErrors.propTypes = {
  errors: PropTypes.array.isRequired,
}

export default ValidationErrors;
